export default {
  "divider": "_divider_11c5fj"
};